import { createAsyncThunk } from "@reduxjs/toolkit";
import { SiteDataSchema, type SiteDataType } from "../model/types";

import { apiRequest } from "@/shared/api/corsProxy";

export const fetchSiteData = createAsyncThunk<
    SiteDataType,
    void,
    { rejectValue: string }
>("fetchSiteData", async (_, { rejectWithValue }) => {
    try {

        const response = await apiRequest<{data: SiteDataType, status: string}>('/data/v2/type?type=krasota-spb-data');

        const dataToValidate = response.data;
        const parsed = SiteDataSchema.safeParse(dataToValidate);
        if (!parsed.success) {
            console.error(parsed.error.issues);
            return rejectWithValue("Ошибка валидации данных с сервера");
        }
        return parsed.data;
    } catch (error: unknown) {
        if (error instanceof Error) {
            return rejectWithValue(error.message);
        }
        return rejectWithValue("Ошибка загрузки данных");
    }
});
